import React, { useCallback } from "react";
import { GoodsamInsuranceModal } from "components/GoodsamInsuranceModal";

const InsurancePlan = ({
  rvData,
  insuranceId,
  setInsuranceId,
  showBookingInsuranceModal,
  setShowBookingInsuranceModal,
  rental_type
}) => {

  const toggleOpen = useCallback(() => {
    setShowBookingInsuranceModal((p) => !p);
  }, [setShowBookingInsuranceModal]);

  const onSave = useCallback(
    (currentPlan) => {
      setInsuranceId(currentPlan.id);
      toggleOpen();
    },
    [setInsuranceId, toggleOpen]
  );

  return (
    <>
      {showBookingInsuranceModal && (
        <GoodsamInsuranceModal
          rvId={rvData.id}
          show={showBookingInsuranceModal}
          onClose={toggleOpen}
          selectedPlanId={insuranceId}
          onSelectPlan={onSave}
          rentalType={rental_type}
          backTo="Back to booking"
        />
      )}
    </>
  );
};

export default InsurancePlan;
